export enum ProductTypeEnum {
  SIMPLE_PRODUCT = 'SimpleProduct',
  CONFIGURABLE_PRODUCT = 'ConfigurableProduct',
  BUNDLE_PRODUCT = 'BundleProduct',
  GROUPED_PRODUCT = 'GroupedProduct',

}
